import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import actionTypes from '../types/leftSideBarTypes';

export const fetchSideBarData = (payload: any): Action<any> => {
  return updateAction(actionTypes.SIDEBAR_DATA, payload);
};

export const setSideBarHeader = (header: any): Action<any> => {
  return updateAction(actionTypes.SIDEBAR_HEADER, header);
};

export const setSideBarRequestPayload = (reqPayload: any): Action<any> => {
  return updateAction(actionTypes.SIDEBAR_REQUEST_PAYLOAD, reqPayload);
};

export const dashBoardRequest = (reqPayload: any): Action<any> => {
  return updateAction(actionTypes.SET_DASHBOARD_REQUEST, reqPayload);
};

export const fetchReimbursementData = (reqPayload: any): Action<any> => {
  return updateAction(actionTypes.FETCH_REIMBURSEMENT_REQUEST, reqPayload);
};

export const fetchReimbursementDataSuccess = (reqPayload: any): Action<any> => {
  return updateAction(actionTypes.FETCH_REIMBURSEMENT_SUCCESS, reqPayload);
};

export const fetchProviderCredits = (): Action<any> => {
  return updateAction(actionTypes.FETCH_PROVIDER_CREDITS, {});
};

export const fetchProviderCreditsSuccess = (reqPayload: any): Action<any> => {
  return updateAction(actionTypes.FETCH_PROVIDER_CREDITS_SUCCESS, reqPayload);
};

export const downloadCreditReport = (): Action<any> => {
  return updateAction(actionTypes.DOWNLOAD_CREDIT_REPORT, {});
};
